<template>
    <div class="news-feed-container">
        <div class="feed-header">
            <h5 class="feed-title">
                <span class="title-icon">&#x1F4F0;</span>
                Latest News
            </h5>
            <span class="ai-badge" title="AI-curated content">
                AI <span class="sparkle">&#x2728;</span>
            </span>
        </div>

        <div class="feed-list">
            <div
                v-for="item in newsItems"
                :key="item.id"
                class="feed-item"
            >
                <div class="feed-icon" :class="'icon-' + item.type">
                    {{ getTypeIcon(item.type) }}
                </div>
                <div class="feed-content">
                    <a :href="item.url" target="_blank" rel="noopener" class="feed-link">
                        <div class="feed-source">{{ item.source }}</div>
                        <div class="feed-text">{{ item.title }}</div>
                    </a>
                </div>
                <div class="feed-time">{{ item.timeAgo }}</div>
            </div>
        </div>

        <!-- TODO: Wire up AI-indexed news feed from conference talks, podcasts, KOL tweets -->
    </div>
</template>

<script>
export default {
    name: 'TokenNewsFeed',

    props: {
        mint: {
            type: String,
            required: true
        },
        tokenSymbol: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            // Mock news data
            newsItems: [
                {
                    id: 1,
                    type: 'twitter',
                    source: '@weremeow',
                    title: 'Big things coming for the Jupiter community this month...',
                    url: 'https://twitter.com',
                    timeAgo: '2h ago'
                },
                {
                    id: 2,
                    type: 'news',
                    source: 'The Block',
                    title: 'Solana DeFi volume surges as Jupiter leads aggregator race',
                    url: 'https://theblock.co',
                    timeAgo: '5h ago'
                },
                {
                    id: 3,
                    type: 'podcast',
                    source: 'Lightspeed',
                    title: '"The role of governance tokens in Solana DeFi..."',
                    url: 'https://lightspeed.fm',
                    timeAgo: '1d ago'
                },
                {
                    id: 4,
                    type: 'conference',
                    source: 'Breakpoint 2024',
                    title: 'Jupiter announces perpetuals integration roadmap',
                    url: 'https://solana.com/breakpoint',
                    timeAgo: '3d ago'
                },
                {
                    id: 5,
                    type: 'twitter',
                    source: '@SolanaLegend',
                    title: 'Thread: Why JUP tokenomics are actually well designed',
                    url: 'https://twitter.com',
                    timeAgo: '4d ago'
                }
            ]
        };
    },

    methods: {
        getTypeIcon(type) {
            const icons = {
                twitter: '🐦',
                news: '📰',
                podcast: '🎙️',
                conference: '🎤',
                blog: '📝'
            };
            return icons[type] || '📄';
        }
    }
};
</script>

<style scoped>
.news-feed-container {
    background: var(--compass-bg-secondary, #1a1a2e);
    border: 1px solid var(--compass-border, rgba(139, 92, 246, 0.2));
    border-radius: var(--compass-radius, 12px);
    padding: 1rem;
}

/* Header */
.feed-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid var(--compass-border, rgba(139, 92, 246, 0.15));
}

.feed-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: var(--compass-text-primary, #e6edf3);
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.title-icon {
    font-size: 1rem;
}

.ai-badge {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.7rem;
    font-weight: 600;
    padding: 0.2rem 0.5rem;
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(236, 72, 153, 0.2));
    border: 1px solid rgba(139, 92, 246, 0.3);
    border-radius: 12px;
    color: var(--compass-purple, #8b5cf6);
}

.sparkle {
    font-size: 0.8rem;
}

/* Feed List */
.feed-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.feed-item {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.65rem;
    background: rgba(139, 92, 246, 0.04);
    border: 1px solid rgba(139, 92, 246, 0.08);
    border-radius: 8px;
    transition: all 0.2s ease;
}

.feed-item:hover {
    background: rgba(139, 92, 246, 0.08);
    border-color: rgba(139, 92, 246, 0.15);
}

.feed-icon {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(139, 92, 246, 0.1);
    border-radius: 6px;
    font-size: 0.9rem;
    flex-shrink: 0;
}

.icon-twitter { background: rgba(29, 161, 242, 0.15); }
.icon-news { background: rgba(239, 68, 68, 0.15); }
.icon-podcast { background: rgba(34, 197, 94, 0.15); }
.icon-conference { background: rgba(245, 158, 11, 0.15); }

.feed-content {
    flex: 1;
    min-width: 0;
}

.feed-link {
    text-decoration: none;
    color: inherit;
}

.feed-source {
    font-size: 0.7rem;
    font-weight: 600;
    color: var(--compass-purple, #8b5cf6);
    margin-bottom: 0.15rem;
}

.feed-text {
    font-size: 0.8rem;
    color: var(--compass-text-primary, #e6edf3);
    line-height: 1.35;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.feed-time {
    font-size: 0.65rem;
    color: var(--compass-text-secondary, #7d8590);
    white-space: nowrap;
    flex-shrink: 0;
}

/* Footer */
.feed-footer {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px solid var(--compass-border, rgba(139, 92, 246, 0.1));
    text-align: center;
}

.mock-notice {
    color: var(--compass-text-secondary, #7d8590);
    opacity: 0.7;
}

/* Light mode */
body:not(.dark-mode) .news-feed-container,
body:not(.dark-mode) .news-feed-container {
    background: #ffffff;
}

body:not(.dark-mode) .feed-text,
body:not(.dark-mode) .feed-text {
    color: #1f2937;
}
</style>
